// Convert previously shared ?shapes= links to Shopify's native filter URL.
// Full navigation keeps counts, pagination, sorting and Back server-consistent.
(function () {
  const url = new URL(window.location.href);
  const old = url.searchParams.get('shapes');
  if (!old) return;
  const allowed = ['Round','Oval','Emerald','Cushion','Elongated Cushion','Old Mine','Pear','Marquise','Radiant','Princess','Asscher','Heart'];
  const selected = [...new Set(old.split(/[+ ]/).map(v =>
    allowed.find(shape => v === shape.toLowerCase().replace(/ /g, '-') + '-engagement-ring')).filter(Boolean))];
  if (!selected.length) return;
  if (url.pathname.includes('lab-grown-engagement-rings')) url.pathname = '/collections/engagement-rings';
  url.searchParams.delete('shapes');
  url.searchParams.delete('page');
  url.searchParams.delete('filter.p.m.beylora.diamond_shape');
  selected.forEach(shape => url.searchParams.append('filter.p.m.beylora.diamond_shape', shape));
  window.location.replace(url.pathname + url.search + url.hash);
})();
